var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'whatwg-fetch';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route, } from 'react-router-dom';
import { Layer, Source, Marker } from 'react-map-gl/maplibre';
import { useImmer } from "use-immer";
import { Container, Tooltip, Whisper } from 'rsuite';
// Local Components
import ResourceMapUI from './resource-map-components/ResourceMapUI';
import { clusterCountLayer, clusterLayer, cityFill, cityHover, cityLine, countyFill, countyHover, countyLine, stateFill, stateLine, unclusteredPointLayer, allPointLayer, } from './resource-map-components/resourceMapStyles';
import BaseMap from './shared-map-components/BaseMap';
import { ResourceModal } from './resource-map-components/ResourceModal';
import { ModalActionButtons } from './resource-map-components/ModalActionButtons';
import { SelectedResourceContent } from './resource-map-components/SelectedResourceContent';
import bbox from '@turf/bbox';
var defaultGlobalConfig = {
    baseRoute: 'map',
    apiRoute: '/api/pages/spending_map/getRequests',
    pageTitle: '',
    pageBlurb: '',
    mapLocationName: '',
    resourceLabel: 'event',
    countySuffixLabel: ' County',
    stateAbbr: 'CA',
    useFiscalYear: false,
    defaultFilter: {
        featured: false,
        initial: false,
        county: '',
        city: '',
        perPage: 50,
        page: 1,
        year: '',
        benefits: '',
        category: '',
        agency: '',
        recipient: '',
        fundingStream: '',
        amount: '',
        query: '',
        queryCol: '',
        orderBy: '',
        sortDir: '',
    },
};
var defaultGlobalState = {
    loading: false,
    updating: false,
    filteredSpendingRequests: [],
    map: null,
    clusters: [],
    selected: [],
    modalResource: null,
    prevModalResource: null,
    nextModalResource: null,
    fundingStream: null,
    dateScope: {
        start: undefined,
        end: undefined,
    },
    types: [],
    zipCode: null,
    zipCoordinates: null,
    zipRadius: 50,
    zipRadiusPolygon: null,
    totalRows: 0,
    currentFilter: defaultGlobalConfig.defaultFilter || {},
};
var defaultListConfig = {
    showFilterTools: true,
    showFilterString: true,
    showSortBy: true,
    showFilterByCounty: false,
    countyFilterPreposition: 'in',
    distinctColumns: [],
    distinctColValues: {},
    initialDistinctColValues: {},
    filters: [],
    filterYearPrefixLabel: '',
    agencyPrefix: 'from the ',
    fundingStreamPrefix: 'and funded by ',
    yearPrefix: 'during ',
};
var defaultMapConfig = {
    allowZoom: true,
    allowFilterCounty: false,
    allowCountyClick: true,
    clusterMaxZoom: 15,
    clusterRadius: 15,
    showClusters: true,
    showClustersZoomedOut: false,
    showPinsZoomedOut: false,
    clusters: ['default'],
    clusterBy: 'eventType',
    showCountyTooltips: true,
    showCityTooltips: true,
    showMapTiles: true,
    showFilterReset: false,
    mapTiles: 'rastertiles/voyager',
    margin: 10,
    minZoom: 4,
    maxZoom: 18,
    sourceOrder: ['counties'],
    interactiveLayers: ['countyFills'],
    vectorStyle: '',
};
var defaultModalConfig = {
    showShare: false,
};
var ResourceMap = function (_a) {
    var _b, _c, _d;
    var config = _a.config;
    var mapRef = useRef();
    var globalConfig = useImmer(__assign(__assign(__assign({}, defaultGlobalConfig), config.global), { defaultFilter: __assign(__assign({}, defaultGlobalConfig.defaultFilter), (_b = config === null || config === void 0 ? void 0 : config.global) === null || _b === void 0 ? void 0 : _b.defaultFilter) }))[0];
    // Make sure config.selected is in array format even if single uid string
    var selectedArray = Array.isArray(config.selected) ? config.selected : (typeof config.selected == 'string') ? [config.selected] : [];
    var _e = useImmer(__assign(__assign({}, defaultGlobalState), { currentFilter: __assign(__assign({}, defaultGlobalConfig.defaultFilter), globalConfig.defaultFilter), selected: selectedArray })), globalState = _e[0], setGlobalState = _e[1];
    var _f = useImmer(__assign(__assign({}, defaultListConfig), config.list)), listConfig = _f[0], setListConfig = _f[1];
    var mapConfig = useImmer(__assign(__assign({}, defaultMapConfig), config.map))[0];
    var modalConfig = useImmer(__assign(__assign({}, defaultModalConfig), config.modal))[0];
    var _g = useImmer({
        modalResource: (selectedArray === null || selectedArray === void 0 ? void 0 : selectedArray[0]) || null,
        prevModalResource: null,
        nextModalResource: (selectedArray === null || selectedArray === void 0 ? void 0 : selectedArray[1]) || null,
    }), modalState = _g[0], setModalState = _g[1];
    var _h = useImmer(config.spendingRequestStore || {}), dataByUid = _h[0], setDataByUid = _h[1];
    var _j = useImmer(selectedArray || []), currentList = _j[0], setCurrentList = _j[1];
    var _k = useImmer(selectedArray || []), modalList = _k[0], setModalList = _k[1];
    var _l = useImmer({
        'type': 'FeatureCollection',
        'features': []
    }), markers = _l[0], setMarkers = _l[1];
    var updateModalResource = function (itemId) {
        if (!itemId)
            itemId = modalList[0] || null;
        var filteredIndex = modalList.findIndex(function (filtereditemId) { return (filtereditemId === itemId); });
        var prevModalResource = modalList[filteredIndex - 1] || null;
        var nextModalResource = modalList[filteredIndex + 1] || null;
        setModalState(function (draft) {
            draft.modalResource = itemId;
            draft.prevModalResource = prevModalResource;
            draft.nextModalResource = nextModalResource;
        });
    };
    useEffect(function () {
        if (modalList.length) {
            var missingData = modalList.filter(function (uid) { return Boolean(!dataByUid[uid]); });
            if (missingData.length)
                fetchUids(missingData);
            modalState.modalResource ? updateModalResource(modalState.modalResource) : updateModalResource(modalList[0]);
        }
        else {
            updateModalResource();
        }
    }, [modalList]);
    var onModalClose = function () {
        setModalList([]);
    };
    // GeoJSON data for shape layers
    var _m = useState(undefined), mapStateSource = _m[0], setStateShape = _m[1];
    var _o = useState(undefined), mapDistrictSource = _o[0], setDistrictShape = _o[1];
    var _p = useState(undefined), mapCountiesSource = _p[0], setCountiesShape = _p[1];
    var _q = useState(undefined), mapCitiesSource = _q[0], setCitiesShape = _q[1];
    var mapSources = {
        state: mapStateSource,
        district: mapDistrictSource,
        counties: mapCountiesSource,
        cities: mapCitiesSource,
    };
    var fetchRegions = function () {
        var setters = {
            state: setStateShape,
            district: setDistrictShape,
            counties: setCountiesShape,
            cities: setCitiesShape,
        };
        var sources = mapConfig.sourceData || {};
        Object.entries(sources).forEach(function (_a) {
            var source = _a[0], url = _a[1];
            fetch(url).then(function (res) {
                res.json().then(function (data) {
                    if (typeof setters[source] == 'function') {
                        setters[source](data);
                    }
                });
            });
        });
    };
    useEffect(function () {
        if (!(mapCitiesSource === null || mapCitiesSource === void 0 ? void 0 : mapCitiesSource.features))
            return;
        var cityFeatures = mapCitiesSource.features.map(function (feature) { return feature.properties.NAME; });
        cityFeatures = cityFeatures.sort();
        setListConfig(function (draft) {
            draft.distinctColValues.city = cityFeatures;
        });
    }, [mapCitiesSource]);
    useEffect(function () {
        if (!(mapCountiesSource === null || mapCountiesSource === void 0 ? void 0 : mapCountiesSource.features))
            return;
        var countyFeatures = mapCountiesSource.features.map(function (feature) { return feature.properties.NAME; });
        countyFeatures = countyFeatures.sort();
        setListConfig(function (draft) {
            draft.distinctColValues.county = countyFeatures;
        });
    }, [mapCountiesSource]);
    var getFeatureBounds = function (collection) {
        var _a;
        var newBounds = {};
        (_a = collection === null || collection === void 0 ? void 0 : collection.features) === null || _a === void 0 ? void 0 : _a.forEach(function (feature) {
            var bounds = bbox(feature);
            var name = feature.properties.NAME;
            if (name)
                newBounds[name] = bounds;
        });
        return newBounds;
    };
    var _r = useState({}), allCountyBounds = _r[0], setCountyBounds = _r[1];
    useEffect(function () {
        if (!mapCountiesSource)
            return;
        var newBounds = getFeatureBounds(mapCountiesSource);
        setCountyBounds(__assign(__assign({}, allCountyBounds), newBounds));
    }, [mapCountiesSource]);
    var _s = useState({}), allCityBounds = _s[0], setCityBounds = _s[1];
    useEffect(function () {
        if (!mapCitiesSource)
            return;
        var newBounds = getFeatureBounds(mapCitiesSource);
        setCityBounds(__assign(__assign({}, allCityBounds), newBounds));
    }, [mapCitiesSource]);
    var fetchUids = function (uidList) {
        var params = __assign({ uids: uidList }, globalState.currentFilter);
        fetch(globalConfig.apiRoute + '?' + new URLSearchParams(params)).then(function (res) {
            res.json().then(function (data) {
                var spendingRequestStore = data.spendingRequestStore;
                setDataByUid(__assign(__assign({}, dataByUid), spendingRequestStore));
            });
        });
    };
    // GeoJSON data for symbol layers
    var fetchResources = function () {
        var params = __assign({ geoJSONMarkers: true, distinctColumns: listConfig.distinctColumns, useFiscalYear: globalConfig.useFiscalYear }, globalState.currentFilter);
        fetch(globalConfig.apiRoute + '?' + new URLSearchParams(params)).then(function (res) {
            res.json().then(function (data) {
                var _a;
                var mapPins = data.mapPins, filteredSpendingRequests = data.filteredSpendingRequests, distinctColValues = data.distinctColValues, spendingRequestStore = data.spendingRequestStore;
                setMarkers(mapPins);
                setDataByUid(__assign(__assign({}, dataByUid), spendingRequestStore));
                if (globalState.currentFilter.page > 1) {
                    setCurrentList(__spreadArray(__spreadArray([], currentList, true), filteredSpendingRequests, true));
                }
                else {
                    setCurrentList(filteredSpendingRequests);
                }
                setGlobalState(function (draft) {
                    draft.totalRows = (filteredSpendingRequests === null || filteredSpendingRequests === void 0 ? void 0 : filteredSpendingRequests.length) ? spendingRequestStore[filteredSpendingRequests[0]]['TotalRows'] : 0;
                });
                if (!distinctColValues || !Object.keys(distinctColValues).length)
                    return;
                var initialDistinctColValues = __assign({}, listConfig.initialDistinctColValues);
                if ((_a = listConfig.filters) === null || _a === void 0 ? void 0 : _a.length) {
                    listConfig.filters.forEach(function (filterRow) {
                        filterRow.forEach(function (filter) {
                            var _a;
                            var scoped = true;
                            if (typeof filter.scoped == 'boolean' && filter.scoped === false)
                                scoped = false;
                            if (scoped)
                                return;
                            var hasInitial = Boolean((_a = initialDistinctColValues === null || initialDistinctColValues === void 0 ? void 0 : initialDistinctColValues[filter.column]) === null || _a === void 0 ? void 0 : _a.length);
                            // If the filter field doesn't scope and initial isn't set yet
                            if (!scoped && !hasInitial) {
                                initialDistinctColValues[filter.column] = distinctColValues[filter.column];
                            }
                            // If the filter field doesn't scope with other filters then delete the new DB values
                            if (!scoped) {
                                if (hasInitial) {
                                    distinctColValues[filter.column] = initialDistinctColValues === null || initialDistinctColValues === void 0 ? void 0 : initialDistinctColValues[filter.column];
                                }
                            }
                        });
                    });
                }
                if (!distinctColValues)
                    return;
                setListConfig(function (draft) {
                    if (Object.keys(initialDistinctColValues).length)
                        draft.initialDistinctColValues = initialDistinctColValues;
                    draft.distinctColValues = __assign(__assign({}, draft.distinctColValues), distinctColValues);
                });
            });
        });
    };
    useEffect(function () {
        fetchResources();
    }, [globalState.currentFilter]);
    var handleMapLoad = function (_a) {
        var _map = _a.target;
        fetchRegions();
        fetchResources();
    };
    var _t = useState(''), hoveredCounty = _t[0], setHoveredCounty = _t[1];
    var _u = useState(''), hoveredCity = _u[0], setHoveredCity = _u[1];
    var _v = useState('grab'), mapCursor = _v[0], setMapCursor = _v[1];
    var handleMapHover = function (event) {
        var _a, _b, _c, _d;
        var hoveredRegionFragment = event.features && event.features[0];
        var hoveredCountyName = ((_a = hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.layer) === null || _a === void 0 ? void 0 : _a.source) == 'counties' ? (hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.properties.name) || (hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.properties.NAME) || (hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.properties.COUNTY_NAM) || '' : '';
        var hoveredCityName = ((_b = hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.layer) === null || _b === void 0 ? void 0 : _b.source) == 'cities' ? (hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.properties.name) || (hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.properties.NAME) || '' : '';
        var hoveredIsCluster = Boolean((_c = hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.properties) === null || _c === void 0 ? void 0 : _c.cluster);
        var hoveredUid = ((_d = hoveredRegionFragment === null || hoveredRegionFragment === void 0 ? void 0 : hoveredRegionFragment.properties) === null || _d === void 0 ? void 0 : _d['uid']) || '';
        if (hoveredCountyName) {
            setHoveredCounty(hoveredCountyName);
            setHoveredCity('');
        }
        else if (hoveredCityName) {
            setHoveredCounty('');
            setHoveredCity(hoveredCityName);
        }
        else {
            setHoveredCounty('');
            setHoveredCity('');
        }
        if (hoveredUid) {
            selectResources([hoveredUid]);
        }
        else {
            selectResources([]);
        }
        setMapCursor((hoveredUid || hoveredIsCluster) ? 'pointer' : 'grab');
    };
    var handleMapMouseOut = function (event) {
        setHoveredCounty('');
        setHoveredCity('');
        selectResources([]);
    };
    var hoveredCountyFilter = useMemo(function () { return ['==', 'NAME', hoveredCounty]; }, [hoveredCounty]);
    var hoveredCityFilter = useMemo(function () { return ['==', 'NAME', hoveredCity]; }, [hoveredCity]);
    var _w = useState(), currentBounds = _w[0], setCurrentBounds = _w[1];
    var _x = useState(0), mapBoundsReset = _x[0], resetMapBounds = _x[1];
    var resetMap = function () {
        setGlobalState(function (draft) {
            draft.currentFilter = globalConfig.defaultFilter;
        });
        resetMapBounds(mapBoundsReset + 1);
    };
    var resetFilters = function () {
        setGlobalState(function (draft) {
            draft.currentFilter = globalConfig.defaultFilter;
        });
    };
    var nextPage = function () {
        setGlobalState(function (draft) {
            draft.currentFilter.page = globalState.currentFilter.page + 1;
        });
    };
    var handleMapClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var clickedRegionFragment, clickedCountyName, clickedCityName, clickedIsCluster, clickedUid, map, features, clusterSource_1, recursiveResourceFinder;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            clickedRegionFragment = event.features && event.features[0];
            clickedCountyName = ((_a = clickedRegionFragment === null || clickedRegionFragment === void 0 ? void 0 : clickedRegionFragment.layer) === null || _a === void 0 ? void 0 : _a.source) == 'counties' ? (clickedRegionFragment === null || clickedRegionFragment === void 0 ? void 0 : clickedRegionFragment.properties.name) || (clickedRegionFragment === null || clickedRegionFragment === void 0 ? void 0 : clickedRegionFragment.properties.NAME) || '' : '';
            clickedCityName = ((_b = clickedRegionFragment === null || clickedRegionFragment === void 0 ? void 0 : clickedRegionFragment.layer) === null || _b === void 0 ? void 0 : _b.source) == 'cities' ? (clickedRegionFragment === null || clickedRegionFragment === void 0 ? void 0 : clickedRegionFragment.properties.name) || (clickedRegionFragment === null || clickedRegionFragment === void 0 ? void 0 : clickedRegionFragment.properties.NAME) || '' : '';
            clickedIsCluster = Boolean((_c = clickedRegionFragment === null || clickedRegionFragment === void 0 ? void 0 : clickedRegionFragment.properties) === null || _c === void 0 ? void 0 : _c.cluster);
            clickedUid = ((_d = clickedRegionFragment === null || clickedRegionFragment === void 0 ? void 0 : clickedRegionFragment.properties) === null || _d === void 0 ? void 0 : _d['uid']) || '';
            if (clickedCountyName) {
                setGlobalState(function (draft) {
                    draft.currentFilter.county = clickedCountyName;
                    draft.currentFilter.city = '';
                });
                setHoveredCounty('');
                setHoveredCity('');
            }
            else if (clickedCityName) {
                setGlobalState(function (draft) {
                    draft.currentFilter.county = '';
                    draft.currentFilter.city = clickedCityName;
                });
                setHoveredCounty('');
                setHoveredCity('');
            }
            else if (clickedIsCluster) {
                if (clickedRegionFragment && ((_e = clickedRegionFragment.geometry) === null || _e === void 0 ? void 0 : _e.type) == 'Point') {
                    map = mapRef.current;
                    if (map) {
                        features = map.queryRenderedFeatures(event.point, {
                            layers: ['clusters']
                        });
                        clusterSource_1 = map.getSource('clusteredMarkers');
                        setModalList(function (draft) {
                            draft = [];
                        });
                        recursiveResourceFinder = function (feature) { return __awaiter(void 0, void 0, Promise, function () {
                            var found, nestedFeatures;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        found = [];
                                        if (!((_a = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _a === void 0 ? void 0 : _a.uid)) return [3 /*break*/, 1];
                                        found.push(feature.properties.uid);
                                        return [3 /*break*/, 3];
                                    case 1:
                                        if (!((_b = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _b === void 0 ? void 0 : _b.cluster)) return [3 /*break*/, 3];
                                        return [4 /*yield*/, clusterSource_1.getClusterLeaves(feature.properties.cluster_id, Infinity, 0)];
                                    case 2:
                                        nestedFeatures = _c.sent();
                                        nestedFeatures.forEach(function (feature) { var _a; return found.push((_a = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _a === void 0 ? void 0 : _a.uid); });
                                        _c.label = 3;
                                    case 3: return [2 /*return*/, found];
                                }
                            });
                        }); };
                        recursiveResourceFinder(features[0]).then(function (foundResources) {
                            setModalList(function (draft) {
                                draft.push.apply(draft, foundResources);
                            });
                        });
                    }
                }
            }
            else if (clickedUid) {
                setModalList(function (draft) {
                    draft.push(clickedUid);
                });
            }
            return [2 /*return*/];
        });
    }); };
    var countyVisibilityFilter = useMemo(function () {
        var mapFocusedOnNonCounty = Boolean(globalState.currentFilter.city);
        if (mapFocusedOnNonCounty) {
            return (['has', 'null']);
        }
        else {
            return (['!=', 'NAME', globalState.currentFilter.county]);
        }
    }, [globalState.currentFilter.county, globalState.currentFilter.city]);
    var cityVisibilityFilter = useMemo(function () {
        return (['!=', 'NAME', globalState.currentFilter.city]);
    }, [globalState.currentFilter.city]);
    var showClustersFilter = useMemo(function () {
        var showClusters = false;
        var focusedOnCounty = Boolean(globalState.currentFilter.county && !['all', 'statewide'].includes(globalState.currentFilter.county));
        var focusedOnCity = Boolean(globalState.currentFilter.city && !['all', 'statewide'].includes(globalState.currentFilter.city));
        var focusedOnRegion = Boolean(focusedOnCounty || focusedOnCity);
        if (focusedOnRegion && mapConfig.showClusters)
            showClusters = true;
        if (mapConfig.showClustersZoomedOut && mapConfig.showClusters)
            showClusters = true;
        if (showClusters) {
            return (['has', 'point_count']);
        }
        else {
            return (['has', 'null']);
        }
    }, [globalState.currentFilter.county, globalState.currentFilter.city]);
    var showMarkersFilter = useMemo(function () {
        var focusedOnCounty = Boolean(globalState.currentFilter.county && !['all', 'statewide'].includes(globalState.currentFilter.county));
        var focusedOnCity = Boolean(globalState.currentFilter.city && !['all', 'statewide'].includes(globalState.currentFilter.city));
        var focusedOnRegion = Boolean(focusedOnCounty || focusedOnCity);
        if (focusedOnRegion) {
            return (['!', ['has', 'point_count']]);
        }
        else {
            return (['==', 'null', 'null']);
        }
    }, [globalState.currentFilter.county, globalState.currentFilter.city]);
    var showAllMarkersFilter = useMemo(function () {
        var focusedOnCounty = Boolean(globalState.currentFilter.county && !['all', 'statewide'].includes(globalState.currentFilter.county));
        var focusedOnCity = Boolean(globalState.currentFilter.city && !['all', 'statewide'].includes(globalState.currentFilter.city));
        var focusedOnRegion = Boolean(focusedOnCounty || focusedOnCity);
        if (focusedOnRegion) {
            return (['has', 'point_count']);
        }
        else {
            return (['!', ['has', 'point_count']]);
        }
    }, [globalState.currentFilter.county, globalState.currentFilter.city]);
    useEffect(function () {
        if (globalState.currentFilter.county || globalState.currentFilter.city) {
            var countyBounds = allCountyBounds[globalState.currentFilter.county];
            var cityBounds = allCityBounds[globalState.currentFilter.city];
            if (countyBounds) {
                setCurrentBounds(countyBounds);
            }
            else if (cityBounds) {
                setCurrentBounds(cityBounds);
            }
        }
        else {
            setCurrentBounds(undefined);
        }
    }, [globalState.currentFilter.county, globalState.currentFilter.city]);
    var selectResources = function (items) {
        setGlobalState(function (draft) {
            draft.selected = items || [];
        });
    };
    var updateFilter = function (newFilter) {
        setGlobalState(function (draft) {
            draft.currentFilter = __assign(__assign({}, draft.currentFilter), newFilter);
        });
    };
    var _y = useState(mapConfig.interactiveLayers), interactiveLayers = _y[0], setInteractiveLayers = _y[1];
    useEffect(function () {
        if (globalState.currentFilter.county || globalState.currentFilter.city) {
            var layers = __spreadArray(__spreadArray([], mapConfig.interactiveLayers, true), ['clusters', 'unclusteredPoints'], false);
            setInteractiveLayers(layers);
        }
        else {
            var layers = __spreadArray([], mapConfig.interactiveLayers, true);
            setInteractiveLayers(layers);
        }
    }, [globalState.currentFilter.county, globalState.currentFilter.city]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Whisper, { open: Boolean(hoveredCounty || hoveredCity), placement: 'top', enterable: false, followCursor: true, preventOverflow: true, speaker: React.createElement(Tooltip, null, (hoveredCounty && "".concat(hoveredCounty, " County"))
                || (hoveredCity && "".concat(hoveredCity))
                || '') },
            React.createElement(Container, null,
                React.createElement(BaseMap, { id: "resourceMap", cursor: mapCursor, mapConfig: mapConfig, globalConfig: globalConfig, currentBounds: currentBounds, resetBounds: mapBoundsReset, onLoad: handleMapLoad, onHover: handleMapHover, onMouseOut: handleMapMouseOut, onClick: handleMapClick, interactiveLayerIds: interactiveLayers, minZoom: mapConfig.minZoom, maxZoom: mapConfig.maxZoom, layers: React.createElement(React.Fragment, null,
                        mapConfig.sourceOrder.map(function (source) {
                            if (!mapSources[source])
                                return;
                            switch (source) {
                                case 'state': return (React.createElement(Source, { key: 'state', id: 'state', type: 'geojson', data: mapStateSource },
                                    React.createElement(Layer, __assign({ beforeId: 'Country border' }, stateFill)),
                                    React.createElement(Layer, __assign({ beforeId: 'Country border' }, stateLine))));
                                case 'district': return (React.createElement(Source, { key: 'district', id: 'district', type: 'geojson', data: mapDistrictSource },
                                    React.createElement(Layer, __assign({ beforeId: 'Country border', filter: countyVisibilityFilter }, countyFill)),
                                    React.createElement(Layer, __assign({ beforeId: 'Country border', filter: hoveredCountyFilter }, countyHover)),
                                    React.createElement(Layer, __assign({ beforeId: 'Country border' }, countyLine))));
                                case 'counties': return (React.createElement(Source, { key: 'counties', id: 'counties', type: 'geojson', data: mapCountiesSource },
                                    React.createElement(Layer, __assign({ beforeId: 'Country border', filter: countyVisibilityFilter }, countyFill)),
                                    React.createElement(Layer, __assign({ beforeId: 'Country border', filter: hoveredCountyFilter }, countyHover)),
                                    React.createElement(Layer, __assign({ beforeId: 'Country border' }, countyLine))));
                                case 'cities': return (React.createElement(Source, { key: 'cities', id: 'cities', type: 'geojson', data: mapCitiesSource },
                                    React.createElement(Layer, __assign({ beforeId: 'Other border', filter: cityVisibilityFilter }, cityFill)),
                                    React.createElement(Layer, __assign({ beforeId: 'Other border', filter: hoveredCityFilter }, cityHover)),
                                    React.createElement(Layer, __assign({ beforeId: 'Other border' }, cityLine))));
                                default:
                                    return (React.createElement(React.Fragment, null));
                            }
                        }),
                        markers && (React.createElement(Source, { id: 'clusteredMarkers', type: 'geojson', data: markers, cluster: mapConfig.showClusters, clusterMaxZoom: mapConfig.clusterMaxZoom, clusterRadius: mapConfig.clusterRadius },
                            React.createElement(Layer, __assign({ filter: showClustersFilter }, clusterLayer)),
                            React.createElement(Layer, __assign({ filter: showClustersFilter }, clusterCountLayer)),
                            React.createElement(Layer, __assign({ filter: showMarkersFilter }, unclusteredPointLayer)))),
                        Boolean(markers && mapConfig.showPinsZoomedOut && !mapConfig.showClustersZoomedOut) &&
                            React.createElement(Source, { id: 'markers', type: 'geojson', data: markers, cluster: false },
                                React.createElement(Layer, __assign({ beforeId: 'Place labels', filter: showAllMarkersFilter }, allPointLayer))),
                        Boolean(markers && ((_c = globalState.selected) === null || _c === void 0 ? void 0 : _c.length)) && ((_d = globalState.selected) === null || _d === void 0 ? void 0 : _d.map(function (uid) {
                            var _a, _b;
                            var resource = dataByUid[uid];
                            return Boolean((_a = resource === null || resource === void 0 ? void 0 : resource.addresses) === null || _a === void 0 ? void 0 : _a.length) && ((_b = resource === null || resource === void 0 ? void 0 : resource.addresses) === null || _b === void 0 ? void 0 : _b.map(function (_a, index) {
                                var lat = _a.lat, lng = _a.lng;
                                return (React.createElement(Marker, { key: "".concat(uid, "--").concat(index), longitude: lng, latitude: lat, anchor: 'bottom', style: { pointerEvents: 'none' } },
                                    React.createElement("svg", { className: "EventMap__pin", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 27 40" },
                                        React.createElement("path", { className: "EventMap__pinMarker", d: "M25.78 19.44C29.66 10.76 23.84.57 14.35.02 14.07.01 13.78 0 13.5 0c-.29 0-.57.01-.85.02C3.16.57-2.66 10.76 1.22 19.44L13.5 40l12.28-20.56z" }),
                                        React.createElement("circle", { className: "EventMap__pinEye", cx: "13.5", cy: "12.41", r: "6.81" }))));
                            }));
                        }))), mapRef: mapRef },
                    React.createElement(ResourceMapUI, { globalConfig: globalConfig, globalState: globalState, listConfig: listConfig, updateFilter: updateFilter, currentList: currentList, selectedResources: globalState.selected, dataByUid: dataByUid, onResetMap: resetMap, onResetFilters: resetFilters, onUpdateModalResource: updateModalResource, onSelectResource: selectResources, nextPage: nextPage })))),
        React.createElement(ResourceModal, { isOpen: Boolean(modalState.modalResource), onClose: onModalClose, actionButtons: React.createElement(ModalActionButtons, { updateModalResource: updateModalResource, currentModalResource: modalState.modalResource, prevModalResource: modalState.prevModalResource, nextModalResource: modalState.nextModalResource, modalList: modalList }) }, (modalState.modalResource && dataByUid[modalState.modalResource]) &&
            React.createElement(SelectedResourceContent, { modalResource: dataByUid[modalState.modalResource], showShare: modalConfig.showShare })),
        React.createElement(Switch, null,
            React.createElement(Route, { path: "/".concat(globalConfig.baseRoute) }),
            React.createElement(Route, { path: '/*' }))));
};
var mapContainer = window.mapContainer || document.getElementById('resource-map');
ReactDOM.render(React.createElement(BrowserRouter, { basename: "/".concat(window.mapProps.global.baseRoute) },
    React.createElement(ResourceMap, { config: window.mapProps || {} })), mapContainer);
// Remove app on Sen-N sites with page transitions
if (typeof window.transitions !== 'undefined' && window.transitions.hooks) {
    window.transitions.hooks.leave(function () {
        ReactDOM.unmountComponentAtNode(mapContainer);
    });
}
